import PanoViewer from "./PanoViewer/PanoViewer";
import { SpinViewer, SpriteImage } from "./SpinViewer";
import { VERSION } from "./version";

export default {
  PanoViewer,
  SpinViewer,
  SpriteImage,
  VERSION
};
